import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';

const AnalyticsFilters = ({ filters, onFilterChange, helperText }) => {
  return (
    <Box className="profile-analytics-filters">
      <Box className="profile-analytics-filter-header">
        <Typography variant="h6" className="profile-analytics-section-title">
          Filter Analytics
        </Typography>
        {helperText ? (
          <Typography variant="body2" className="profile-analytics-helper">
            {helperText}
          </Typography>
        ) : null}
      </Box>

      <Box className="profile-analytics-filter-grid">
        <TextField
          fullWidth
          size="small"
          type="date"
          label="From date"
          value={filters.fromDate}
          onChange={(event) => onFilterChange('fromDate', event.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          fullWidth
          size="small"
          type="date"
          label="To date"
          value={filters.toDate}
          onChange={(event) => onFilterChange('toDate', event.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <FormControl fullWidth size="small">
          <InputLabel id="profile-analytics-period">Period</InputLabel>
          <Select
            labelId="profile-analytics-period"
            value={filters.period}
            label="Period"
            onChange={(event) => onFilterChange('period', event.target.value)}
          >
            <MenuItem value="week">Week</MenuItem>
            <MenuItem value="month">Month</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};

export default AnalyticsFilters;
